// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"35":"2821e846","80":"c36c8c28","288":"b5c41df2","467":"3a1bff11","498":"d649287d","532":"774b2158","777":"bcde214a","808":"d97db876","827":"eac05fa7"}[chunkId] + ".css";
};